var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"check_ui"},[_c('input',{attrs:{"value":"foo","id":_vm.random,"type":"radio"},domProps:{"checked":_vm.value === true || _vm.value === 1},on:{"change":_vm.updateInput}}),_c('label',{attrs:{"for":_vm.random}},[_c('i')])])
}
var staticRenderFns = []

export { render, staticRenderFns }